import React, { useRef, useEffect } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Flex,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { white, newBorder, textPrimary } from "../../utils/colors";
import { CountrySelector, usePhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
// import axios from "axios";

const FormControlPhone = ({
  onBlur,
  label,
  value,
  onChange,
  isRequired,
  isTouched,
  isError,
  errorMessage,
  w,
  defaultCountry,
  labelFontSize,
  zIndex,
}) => {
  const initialValue = value || ""; // The initial value of the phone input
  // The hook should be called inside the function component.
  const { inputValue, country, setCountry, handlePhoneValueChange, inputRef } =
    usePhoneInput({
      defaultCountry: defaultCountry || "lt",
      value: initialValue || "",
      onChange: ({ phone, inputValue, country }) => {
        onChange(phone, inputValue, country); // Pass the new phone value and other details to the onChange handler
      },
    });

  // Function to set caret at the end of the input value
  const setCaretAtEnd = (e) => {
    const inputLength = e.target.value.length;
    e.target.setSelectionRange(inputLength, inputLength);
  };

  const formControlRef = useRef();

  // useEffect(() => {
  //   const fetchIPInfo = async () => {
  //     try {
  //       const apiKey = process.env.REACT_APP_IPIFY_API_KEY; // Your API key
  //       const res = await axios.get(
  //         `https://geo.ipify.org/api/v2/country?apiKey=${apiKey}`
  //       );
  //       const data = res.data;
  //       const country = data.location.country.toLowerCase(); // Get country code in lowercase
  //       setCountry(country); // Set the country code to the phone input
  //     } catch (error) {
  //       console.error("Error fetching IP location:", error);
  //     }
  //   };

  //   fetchIPInfo(); // Call the function when component mounts
  // }, []);

  // useEffect(() => {
  //   const fetchIPInfo = async () => {
  //     try {
  //       const apiKey = process.env.REACT_APP_IPINFO_ACCESS_TOKEN;
  //       const res = await axios.get(`https://ipinfo.io/json?token=${apiKey}`);
  //       const countryCode = res.data.country.toLowerCase();
  //       setCountry(countryCode);
  //     } catch (error) {
  //       console.error("Error fetching IP location:", error);
  //       setCountry(defaultCountry || "lt");
  //     }
  //   };

  //   if (!country) {
  //     fetchIPInfo(); // Fetch the country only if it's not already set
  //   }
  // }, [defaultCountry, country]);

  useEffect(() => {
    const countrySelectButton = formControlRef.current?.querySelector(
      ".react-international-phone-country-selector-button"
    );
    if (countrySelectButton) {
      countrySelectButton.tabIndex = -1;
    }
  }, []);

  // console.log("isTouched", isTouched);
  // console.log("defaultCountry", defaultCountry);
  // console.log("value", value);a
  // console.log("ip", country);

  // console.log("country", country);

  return (
    <>
      <Box
        w={w}
        ref={formControlRef}
        className="phoneInput"
        position="relative"
        zIndex={zIndex ? zIndex : 1}
      >
        <FormControl
          mb={4}
          isRequired={isRequired}
          isInvalid={isTouched && isError}
          w="100%"
          className={
            isError && isTouched
              ? "customPhone customPhone-error"
              : "customPhone"
          }
        >
          <FormLabel
            fontSize={labelFontSize ? labelFontSize : "sm"}
            position="relative"
            color={textPrimary}
          >
            {label}
            {isError && isTouched && (
              <Box position="absolute" top={-1} right={0} zIndex={2}>
                <FormErrorMessage fontSize="xs">
                  {errorMessage}
                </FormErrorMessage>
              </Box>
            )}
          </FormLabel>

          <Flex tabIndex={-1} w="100%">
            <InputGroup
              size="lg"
              w="100%"
              bg={white}
              borderRadius="0.75rem"
              border={`1px solid ${newBorder}`}
              // overflow="hidden"
              zIndex="888"
              _hover={{
                borderColor: "#cbd5e0",
              }}
            >
              <InputLeftElement className="customPhone" w="56px">
                <CountrySelector
                  selectedCountry={country.iso2}
                  onSelect={({ iso2 }) => setCountry(iso2)}
                  style={{
                    border: "none",
                    width: "100%",
                  }}
                />
              </InputLeftElement>

              <Input
                w="100%"
                bg="white"
                type="tel"
                onBlur={() => {
                  if (onBlur) onBlur(); // Propagate onBlur event to parent component
                }}
                color={textPrimary}
                value={inputValue}
                onChange={handlePhoneValueChange}
                defaultcountry={country.iso2 || "lt"}
                ref={inputRef}
                size="lg"
                fontSize={["1rem", "0.938rem"]}
                fontWeight="500"
                border={`0px solid ${newBorder}`}
                borderRadius="0.75rem"
                onFocus={setCaretAtEnd}
                p="0 0 0 66px"

                // _focusVisible={{
                //   zIndex: "1",
                //   borderColor: "primary",
                //   boxShadow: `0 0 0 1px primary`,
                // }}
              />
            </InputGroup>
          </Flex>
        </FormControl>
      </Box>
    </>
  );
};

export default FormControlPhone;
